/**
 * Sign in or create an account, on a board in the workshop. Once signed in it closes back to
 * the workshop, or to `?next=` when another screen sent you (a same-site path only, so the link
 * cannot bounce a fresh login off to somewhere else). `?signup` opens on "create account".
 */

import { Navigate, useSearchParams } from 'react-router-dom';
import { AuthGate } from '../components/AuthGate';

/** `/games` yes; `//evil.example`, `https://…` and `/\evil` no. */
export function safeNext(next: string | null): string {
  return next && /^\/(?![/\\])/u.test(next) ? next : '/';
}

export function SignIn() {
  const [params] = useSearchParams();
  return (
    <AuthGate title="Your Account">
      <Navigate to={safeNext(params.get('next'))} replace />
    </AuthGate>
  );
}
